import { render, staticRenderFns } from "./CheckoutButton.vue?vue&type=template&id=0c5e5549&scoped=true&"
import script from "./CheckoutButton.vue?vue&type=script&lang=js&"
export * from "./CheckoutButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutButton.vue?vue&type=style&index=0&id=0c5e5549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e5549",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
